import styled, { css } from 'styled-components';

import { TertiaryButton } from 'brand-guidelines/Buttons-styled-components';
import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { applyStylesForScreenSize, SCREEN_SIZES } from 'brand-guidelines/utils/screenSizeUtils';

export const SsoButtonWrapper = styled(TertiaryButton)`
  padding: 10px 12px;
  display: flex;
  align-items: center;
  gap: 8px;

  border: 1px solid ${BRAND_COLORS.stroke};

  &:hover {
    background-color: ${BRAND_COLORS.lightGray};
  }

  ${applyStylesForScreenSize(
    [SCREEN_SIZES.PHONE],
    css`
      width: 40px;
      height: 40px;
    `,
  )}
`;

// Exists only to target the svg
export const LogoWrapper = styled.div`
  display: contents;

  > svg {
    flex-shrink: 0;
    height: 20px;
    width: 20px;
  }
`;

export const ButtonText = styled.span`
  ${TYPOGRAPHY.CIRCULAR.book}
  color: ${BRAND_COLORS.black};
  white-space: nowrap;
  text-align: center;
  font-size: 14px;
  line-height: 22px;

${applyStylesForScreenSize(
  [SCREEN_SIZES.PHONE],
  css`
    display: none;
    `,
)}
`;
